import PortalDialog, {PortalDialogProperties, PortalDialogState} from "../PortalDialog";
import React, {ReactNode} from "react";
import {Button} from "primereact/button";
import Parameter from "../../parameter/Parameter";
import PortalDocument from "../../../document/PortalDocument";
import DialogDefault from "../../parameter/PortalDialogDefault";
import BarcodeFields from "../../field/barcode/BarcodeFields";
import UnitHelper from "../../../../shared/helper/UnitHelper";
import LengthUnit from "../../../../shared/units/LengthUnit";
import bwipjs, {ToBufferOptions} from "bwip-js";
import BarcodeHelper from "../../../../shared/helper/BarcodeHelper";
import swissqrcode from "../../../../../resources/images/dialog/swissqr/plain/code.png";
import swissqrbill from "../../../../../resources/images/dialog/swissqr/plain/bill.png";
import swissqrdashedbill from "../../../../../resources/images/dialog/swissqr/plain/dashedbill.png";
import swissqrdashedscissorsbill from "../../../../../resources/images/dialog/swissqr/plain/dashedscissorsbill.png";
import swissqrdottedbill from "../../../../../resources/images/dialog/swissqr/plain/dottedbill.png";
import swissqrdottedscissorsbill from "../../../../../resources/images/dialog/swissqr/plain/dottedscissorsbill.png";
import swissqrlinebill from "../../../../../resources/images/dialog/swissqr/plain/linebill.png";
import swissqrlinescissorsbill from "../../../../../resources/images/dialog/swissqr/plain/linescissorsbill.png";
import swissqrpaddingbill from "../../../../../resources/images/dialog/swissqr/padding/paddingbill.png";
import swissqrpaddingdashedbill from "../../../../../resources/images/dialog/swissqr/padding/paddingdashedbill.png";
import swissqrpaddingdashedscissorsbill
	from "../../../../../resources/images/dialog/swissqr/padding/paddingdashedscissorsbill.png";
import swissqrpaddingdottedbill from "../../../../../resources/images/dialog/swissqr/padding/paddingdottedbill.png";
import swissqrpaddingdottedscissorsbill
	from "../../../../../resources/images/dialog/swissqr/padding/paddingdottedscissorsbill.png";
import swissqrpaddinglinebill from "../../../../../resources/images/dialog/swissqr/padding/paddinglinebill.png";
import swissqrpaddinglinescissorsbill
	from "../../../../../resources/images/dialog/swissqr/padding/paddinglinescissorsbill.png";
import swissqrpage from "../../../../../resources/images/dialog/swissqr/page/page.png";
import swissqrdashedpage from "../../../../../resources/images/dialog/swissqr/page/dashedpage.png";
import swissqrdashedscissorspage from "../../../../../resources/images/dialog/swissqr/page/dashedscissorspage.png";
import swissqrdottedpage from "../../../../../resources/images/dialog/swissqr/page/dottedpage.png";
import swissqrdottedscissorspage from "../../../../../resources/images/dialog/swissqr/page/dottedscissorspage.png";
import swissqrlinepage from "../../../../../resources/images/dialog/swissqr/page/linepage.png";
import swissqrlinescissorspage from "../../../../../resources/images/dialog/swissqr/page/linescissorspage.png";
import {InputNumber} from "primereact/inputnumber";
import {Dropdown} from "primereact/dropdown";
import ImageUnit from "../../../../shared/units/ImageUnit";
import {InputSwitch} from "primereact/inputswitch";
import pdf417Example from "../../../../../resources/images/dialog/pdf417_example.png";
import {InputTextarea} from "primereact/inputtextarea";
import {InputText} from "primereact/inputtext";
import FileHelper from "../../../../shared/helper/FileHelper";
import {
	AddBarcode,
	AdminWebserviceStatus,
	AztecBarcode,
	BarcodeCreateOutputFormat,
	DataMatrixBarcode,
	DataMatrixShape,
	Functions,
	Information,
	Pdf417Barcode,
	Pdf417CompactionMode,
	QrBarcode,
	QrCodeErrorCorrection,
	QrSwissPaymentBarcode,
	QrSwissPaymentContent,
	QrSwissPaymentContentFormat,
	QrSwissPaymentFormat,
	QrSwissPaymentLanguage,
	QrSwissPaymentSeparator,
	Rectangle,
	Security
} from "@softvision/webpdf-wsclient-9-typescript/lib/generated-sources";
import {PortalBarcode} from "../../../../shared/models/PortalBarcode";
import {PortalAddBarcode, PortalBarcodeFormat} from "../../../../shared/models/PortalAddBarcode";
import {PortalPdf417Barcode} from "../../../../shared/models/PortalPdf417Barcode";
import Translate from "../../../../shared/translation/Translate";
import Helper from "../../../../shared/components/Helper";
import UserSettings from "../../../session/UserSettings";
import Immutable from "../../../../shared/immutable/Immutable";
import FunctionHelper from "../../../../shared/helper/FunctionHelper";
import {SwissQrCodeForm} from "../../../../shared/models/SwissQrCodeForm";

export const COMPACTION_MODE_NONE: string = 'none';

interface PreviewOptions extends ToBufferOptions {
	eclevel?: string | number;
	layers?: number;
	format?: string;
	columns?: number;
	rows?: number;
}

export interface BarcodeDialogProperties extends PortalDialogProperties<PortalBarcode> {
	userSettings: Immutable<UserSettings>;
}

export interface BarcodeDialogStatus extends PortalDialogState<PortalBarcode> {
	showPreview: boolean;
	showFormDialog: boolean;
	unit: LengthUnit;
	previewBuild: boolean;
}

export default abstract class BarcodeDialog<PROPERTY_TYPE extends BarcodeDialogProperties = any,
	STATUS_TYPE extends BarcodeDialogStatus = any>
	extends PortalDialog<PortalBarcode, PROPERTY_TYPE, STATUS_TYPE> {
	protected barcodePreview?: HTMLCanvasElement;
	protected previewImages: Map<QrSwissPaymentFormat, Map<QrSwissPaymentSeparator, string>>;

	constructor(props: Readonly<PROPERTY_TYPE>) {
		super(props);

		this.state = {
			...this.state,
			showPreview: false,
			showFormDialog: false,
			fieldErrors: new Map<BarcodeFields, string>(),
			unit: LengthUnit.MILLIMETER,
			previewBuild: false
		};

		this.previewImages = new Map<QrSwissPaymentFormat, Map<QrSwissPaymentSeparator, string>>(
			[
				[QrSwissPaymentFormat.CodeOnly, new Map([
					[QrSwissPaymentSeparator.None, swissqrcode]
				])],
				[QrSwissPaymentFormat.BillOnly, new Map([
					[QrSwissPaymentSeparator.None, swissqrbill],
					[QrSwissPaymentSeparator.SolidLine, swissqrlinebill],
					[QrSwissPaymentSeparator.SolidLineWithScissors, swissqrlinescissorsbill],
					[QrSwissPaymentSeparator.DottedLine, swissqrdottedbill],
					[QrSwissPaymentSeparator.DottedLineWithScissors, swissqrdottedscissorsbill],
					[QrSwissPaymentSeparator.DashedLine, swissqrdashedbill],
					[QrSwissPaymentSeparator.DashedLineWithScissors, swissqrdashedscissorsbill]
				])],
				[QrSwissPaymentFormat.BillExtraSpace, new Map([
					[QrSwissPaymentSeparator.None, swissqrpaddingbill],
					[QrSwissPaymentSeparator.SolidLine, swissqrpaddinglinebill],
					[QrSwissPaymentSeparator.SolidLineWithScissors, swissqrpaddinglinescissorsbill],
					[QrSwissPaymentSeparator.DottedLine, swissqrpaddingdottedbill],
					[QrSwissPaymentSeparator.DottedLineWithScissors, swissqrpaddingdottedscissorsbill],
					[QrSwissPaymentSeparator.DashedLine, swissqrpaddingdashedbill],
					[QrSwissPaymentSeparator.DashedLineWithScissors, swissqrpaddingdashedscissorsbill]
				])],
				[QrSwissPaymentFormat.BillPortraitSheet, new Map([
					[QrSwissPaymentSeparator.None, swissqrpage],
					[QrSwissPaymentSeparator.SolidLine, swissqrlinepage],
					[QrSwissPaymentSeparator.SolidLineWithScissors, swissqrlinescissorspage],
					[QrSwissPaymentSeparator.DottedLine, swissqrdottedpage],
					[QrSwissPaymentSeparator.DottedLineWithScissors, swissqrdottedscissorspage],
					[QrSwissPaymentSeparator.DashedLine, swissqrdashedpage],
					[QrSwissPaymentSeparator.DashedLineWithScissors, swissqrdashedscissorspage]
				])]
			]
		)
	}

	public static isEnabled(portalInfo: Information): boolean {
		return FunctionHelper.applyValue(
			portalInfo.webserviceStatus?.webservices?.barcode?.enabled, AdminWebserviceStatus.getEnabledDefault()
		) && FunctionHelper.applyValue(
			portalInfo.functionsStatus?.createBarcode, Functions.getCreateBarcodeDefault()
		);
	}

	protected buildPreview(parameter: PortalAddBarcode): void {
		if (!FunctionHelper.exists(this.barcodePreview) || this.state.previewBuild) {
			return;
		}

		let rotation: number = 0;
		let options: PreviewOptions = {
			bcid: parameter.format!.toString(),
			text: "",
			scale: 4,
			paddingheight: 0,
			paddingwidth: 0
		};

		switch (parameter.format) {
			case PortalBarcodeFormat.aztec:
				options.text = parameter.aztec![0].value!;
				options.paddingheight = parameter.aztec![0].margin;
				options.paddingwidth = parameter.aztec![0].margin;
				rotation = parameter.aztec![0].rotation!;
				options.format = 'full';
				options.eclevel = parameter.aztec![0].errorCorrection;

				if (parameter.aztec![0].layers! > 0) {
					options.layers = parameter.aztec![0].layers;
				}
				break;
			case PortalBarcodeFormat.codabar:
				options.text = parameter.codabar![0].value!;
				options.paddingheight = parameter.codabar![0].margin;
				options.paddingwidth = parameter.codabar![0].margin;
				rotation = parameter.codabar![0].rotation!;
				break;
			case PortalBarcodeFormat.code39:
				options.text = parameter.code39![0].value!;
				options.paddingheight = parameter.code39![0].margin;
				options.paddingwidth = parameter.code39![0].margin;
				rotation = parameter.code39![0].rotation!;
				break;
			case PortalBarcodeFormat.code128:
				options.text = parameter.code128![0].value!;
				options.paddingheight = parameter.code128![0].margin;
				options.paddingwidth = parameter.code128![0].margin;
				rotation = parameter.code128![0].rotation!;
				break;
			case PortalBarcodeFormat.datamatrix:
				options.text = parameter.datamatrix![0].value!;
				options.paddingheight = parameter.datamatrix![0].margin;
				options.paddingwidth = parameter.datamatrix![0].margin;
				rotation = parameter.datamatrix![0].rotation!;
				options.format = parameter.datamatrix![0].shape !==
				DataMatrixShape.Rectangle ?
					DataMatrixShape.Square :
					DataMatrixShape.Rectangle;
				options.eclevel = parameter.datamatrix![0].errorCorrection;
				break;
			case PortalBarcodeFormat.ean8:
				options.text = parameter.ean8![0].value!;
				options.paddingheight = parameter.ean8![0].margin;
				options.paddingwidth = parameter.ean8![0].margin;
				rotation = parameter.ean8![0].rotation!;
				break;
			case PortalBarcodeFormat.ean13:
				options.text = parameter.ean13![0].value!;
				options.paddingheight = parameter.ean13![0].margin;
				options.paddingwidth = parameter.ean13![0].margin;
				rotation = parameter.ean13![0].rotation!;
				break;
			case PortalBarcodeFormat.itf:
				options.text = parameter.itf![0].value!;
				options.paddingheight = parameter.itf![0].margin;
				options.paddingwidth = parameter.itf![0].margin;
				rotation = parameter.itf![0].rotation!;
				break;
			case PortalBarcodeFormat.pdf417:
				options.text = parameter.pdf417![0].value!;
				options.paddingheight = parameter.pdf417![0].margin;
				options.paddingwidth = parameter.pdf417![0].margin;
				rotation = parameter.pdf417![0].rotation!;
				options.eclevel = parameter.pdf417![0].errorCorrection;

				if (parameter.pdf417![0].compact) {
					options.format = "pdf417compact";
				}

				if ((parameter.pdf417![0] as PortalPdf417Barcode).dimensions) {
					options.columns = parameter.pdf417![0].dataCodewordsMin;
					options.rows = parameter.pdf417![0].symbolsPerCodewordMin;
				}
				break;
			case PortalBarcodeFormat.qrcode:
				options.text = parameter.qrcode![0].value!;
				options.eclevel = parameter.qrcode![0].errorCorrection!.toUpperCase();
				options.paddingheight = parameter.qrcode![0].margin;
				options.paddingwidth = parameter.qrcode![0].margin;
				rotation = parameter.qrcode![0].rotation!;
				break;
			case PortalBarcodeFormat.upca:
				options.text = parameter.upca![0].value!;
				options.paddingheight = parameter.upca![0].margin;
				options.paddingwidth = parameter.upca![0].margin;
				rotation = parameter.upca![0].rotation!;
				break;
			case PortalBarcodeFormat.swissqrcode:
				this.setState({
					showPreview: true,
					previewBuild: true
				});
				return;
		}

		switch (rotation) {
			case 0:
				options.rotate = "N";
				break;
			case 90:
				options.rotate = "R";
				break;
			case 180:
				options.rotate = "I";
				break;
			case 270:
				options.rotate = "L";
				break;
		}

		if (FunctionHelper.exists(options.paddingheight)) {
			options.paddingheight = Math.round(options.paddingheight as number);
		}

		if (FunctionHelper.exists(options.paddingwidth)) {
			options.paddingwidth = Math.round(options.paddingwidth as number);
		}

		try {
			bwipjs.toCanvas('barcode-preview', options);

			this.setState({
				showPreview: true,
				previewBuild: true
			});
		} catch (e: any) {
			this.setState({
				showPreview: false,
				previewBuild: true
			});
		}
	}

	protected renderOutputFormatOptions(): ReactNode {
		let parameter: PortalBarcode | undefined = this.state.parameter?.data;

		if (!FunctionHelper.exists(parameter?.add)) {
			return null;
		}

		let addParameter: PortalAddBarcode = parameter!.add as PortalAddBarcode;
		let errors: Map<BarcodeFields, string> = this.state.fieldErrors;

		return (
			<fieldset className="p-col-12 p-grid" hidden={!this.state.fields?.contains(BarcodeFields.OUTPUT)}>
				<div className="p-col-12 p-lg-6 p-grid">
					<label className="p-col-12 p-sm-5" htmlFor="control-output-format">
						<Translate {...this.props} data="barcode.generate.output.label" namespace="dialog"/>
					</label>
					<div className="p-col-12 p-sm-7 p-grid">
						<Dropdown inputId="control-output-format"
								  value={FunctionHelper.applyValue(
									  addParameter.outputFormat, AddBarcode.getOutputFormatDefault()
								  )}
								  options={[
									  {
										  label: Translate.value(
											  "barcode.generate.output.pdf", {ns: "dialog"}
										  ),
										  value: BarcodeCreateOutputFormat.Pdf
									  },
									  {
										  label: Translate.value(
											  "barcode.generate.output.bmp", {ns: "dialog"}
										  ),
										  value: BarcodeCreateOutputFormat.Bmp
									  },
									  {
										  label: Translate.value(
											  "barcode.generate.output.jpg", {ns: "dialog"}
										  ),
										  value: BarcodeCreateOutputFormat.Jpg
									  },
									  {
										  label: Translate.value(
											  "barcode.generate.output.png", {ns: "dialog"}
										  ),
										  value: BarcodeCreateOutputFormat.Png
									  },
									  {
										  label: Translate.value(
											  "barcode.generate.output.tif", {ns: "dialog"}
										  ),
										  value: BarcodeCreateOutputFormat.Tif
									  }
								  ]}
								  onChange={(e) => this.onChange(BarcodeFields.OUTPUT, e.value)}
								  appendTo={document.getElementById("root")}/>
					</div>
				</div>
				<div className="p-col-12 p-lg-6 p-grid" hidden={
					!this.state.fields?.contains(BarcodeFields.FILENAME)
				}>
					<label className="p-col-12 p-sm-5" htmlFor="control-filename">
						<Translate {...this.props} data="barcode.generate.filename.label" namespace="dialog"/>
					</label>
					<div className="p-col-12 p-sm-7">
						<div className={"p-inputgroup" + (errors.has(BarcodeFields.FILENAME) ? " p-invalid" : "")}>
							<InputText id="control-filename" autoFocus={true}
									   className={errors.has(BarcodeFields.FILENAME) ? "p-invalid" : ""}
									   tooltip={errors.has(BarcodeFields.FILENAME) ? Translate.value(
										   errors.get(BarcodeFields.FILENAME)!, {ns: "message"}
									   ) : ""}
									   value={FunctionHelper.applyValue(
										   addParameter?.fileName, PortalAddBarcode.getFileNameDefault()
									   )}
									   onInput={(e) => this.onChange(
										   BarcodeFields.FILENAME, e.currentTarget.value
									   )}/>
							<span className="p-inputgroup-addon">.{FunctionHelper.applyValue(
								addParameter.outputFormat, AddBarcode.getOutputFormatDefault()
							)}</span>
						</div>
						{this.renderFieldError(errors.has(BarcodeFields.FILENAME) ?
							Translate.value(
								errors.get(BarcodeFields.FILENAME)!, {ns: "message"}
							) : ""
						)}
					</div>
				</div>
			</fieldset>
		);
	}

	protected renderContentOptions(): ReactNode {
		let parameter: PortalBarcode | undefined = this.state.parameter?.data;
		let errors: Map<BarcodeFields, string> = this.state.fieldErrors;

		if (!FunctionHelper.exists(parameter?.add)) {
			return null;
		}

		let addParameter: PortalAddBarcode = parameter!.add as PortalAddBarcode;
		let content: string = addParameter.getFormatContent();

		return (
			<fieldset className="p-col-12 p-grid" hidden={!this.state.fields?.contains(BarcodeFields.CONTENT)}>
				<div className="p-col-12 p-lg-6 p-grid"
					 hidden={addParameter.format !== PortalBarcodeFormat.swissqrcode}>
					<label className="p-col-12 p-sm-5" htmlFor="control-content-format">
						<Translate {...this.props} data="barcode.create.format.label" namespace="dialog"/>
					</label>
					<div className="p-col-12 p-sm-7 p-grid">
						<Dropdown inputId="control-content-format"
								  value={FunctionHelper.applyValue(
									  addParameter.qrswiss![0]?.content?.format,
									  QrSwissPaymentContent.getFormatDefault()
								  )}
								  options={[
									  {
										  label: Translate.value(
											  "barcode.create.format.plain", {ns: "dialog"}
										  ),
										  value: QrSwissPaymentContentFormat.Plain
									  },
									  {
										  label: Translate.value(
											  "barcode.create.format.json", {ns: "dialog"}
										  ),
										  value: QrSwissPaymentContentFormat.Json
									  }
								  ]}
								  onChange={(e) => this.onChange(
									  BarcodeFields.SWISSQRCODE_CONTENT_FORMAT, e.value
								  )}
								  appendTo={document.getElementById("root")}/>
					</div>
				</div>
				<div className="p-col-12 p-lg-6 p-grid" hidden={
					addParameter.format !== PortalBarcodeFormat.swissqrcode
				}>
					<label className="p-col-12 p-sm-5">
						<Translate {...this.props} data="barcode.create.content" namespace="dialog"/>
					</label>
					<div className="p-col-12 p-sm-7 p-grid">
						<Button id="control-content-swiss-content" icon="icon icon-list small"
								label={Translate.value("barcode.create.form", {ns: "dialog"})}
								className="dialog-button p-col-12" data-tooltip-id="tooltip"
								data-tooltip-content={
									errors.has(BarcodeFields.CONTENT) ? Translate.value(
										errors.get(BarcodeFields.CONTENT)!, {ns: "message"}
									) : ""
								}
								onClick={() => this.setState({
									showFormDialog: true
								})}/>
						{this.renderFieldError(errors.has(BarcodeFields.CONTENT) ? Translate.value(
							errors.get(BarcodeFields.CONTENT)!, {ns: "message"}
						) : "")}
					</div>
				</div>
				<div className="p-col-12 p-grid" hidden={
					addParameter.format === PortalBarcodeFormat.itf ||
					addParameter.format === PortalBarcodeFormat.ean8 ||
					addParameter.format === PortalBarcodeFormat.ean13 ||
					addParameter.format === PortalBarcodeFormat.codabar ||
					addParameter.format === PortalBarcodeFormat.upca ||
					addParameter.format === PortalBarcodeFormat.swissqrcode
				}>
					<label className="p-col-12 p-sm-5 large-label" htmlFor="control-content-textarea">
						<Translate {...this.props} data="barcode.create.content" namespace="dialog"/>
					</label>
					<div className="p-col-12 p-sm-7 large-input p-grid">
						<InputTextarea id="control-content-textarea" rows={3} value={content}
									   className={errors.has(BarcodeFields.CONTENT) ? "p-invalid" : ""}
									   tooltip={errors.has(BarcodeFields.CONTENT) ? Translate.value(
										   errors.get(BarcodeFields.CONTENT)!, {ns: "message"}
									   ) : ""}
									   onInput={(e) => this.onChange(
										   BarcodeFields.CONTENT, e.currentTarget.value
									   )}/>
						{this.renderFieldError(errors.has(BarcodeFields.CONTENT) ? Translate.value(
							errors.get(BarcodeFields.CONTENT)!, {ns: "message"}
						) : "")}
					</div>
				</div>
				<div className="p-col-12 p-lg-6 p-grid" hidden={
					addParameter.format !== PortalBarcodeFormat.itf &&
					addParameter.format !== PortalBarcodeFormat.ean8 &&
					addParameter.format !== PortalBarcodeFormat.ean13 &&
					addParameter.format !== PortalBarcodeFormat.codabar &&
					addParameter.format !== PortalBarcodeFormat.upca
				}>
					<label className="p-col-12 p-sm-5" htmlFor="control-content-text">
						<Translate {...this.props} data="barcode.create.content" namespace="dialog"/>
					</label>
					<div className="p-col-12 p-sm-7 p-grid">
						<InputText id="control-content-text" value={content}
								   className={errors.has(BarcodeFields.CONTENT) ? "p-invalid" : ""}
								   tooltip={errors.has(BarcodeFields.CONTENT) ? Translate.value(
									   errors.get(BarcodeFields.CONTENT)!, {ns: "message"}
								   ) : ""}
								   onInput={(e) => this.onChange(
									   BarcodeFields.CONTENT, e.currentTarget.value
								   )}/>
						{this.renderFieldError(errors.has(BarcodeFields.CONTENT) ? Translate.value(
							errors.get(BarcodeFields.CONTENT)!, {ns: "message"}
						) : "")}
					</div>
				</div>
			</fieldset>
		);
	}

	protected renderFormatOptions(): ReactNode {
		let parameter: PortalBarcode | undefined = this.state.parameter?.data;

		if (!FunctionHelper.exists(parameter?.add)) {
			return null;
		}

		let addParameter: PortalAddBarcode = parameter!.add as PortalAddBarcode;

		return (
			<>
				<div className="p-col-12 p-lg-6 p-grid" hidden={
					!this.state.fields?.contains(BarcodeFields.FORMAT)
				}>
					<label className="p-col-12 p-sm-5" htmlFor="control-format">
						<Translate {...this.props} data="barcode.format.label" namespace="dialog"/>
					</label>
					<div className="p-col-12 p-sm-7 p-grid">
						<Dropdown inputId="control-format"
								  value={FunctionHelper.applyValue(
									  addParameter.format, PortalAddBarcode.getFormatDefault()
								  )}
								  options={[
									  {
										  label: Translate.value("barcode.format.qrcode", {ns: "dialog"}),
										  value: PortalBarcodeFormat.qrcode
									  },
									  {
										  label: Translate.value(
											  "barcode.format.swissqrcode", {ns: "dialog"}
										  ),
										  value: PortalBarcodeFormat.swissqrcode
									  },
									  {
										  label: Translate.value("barcode.format.aztec", {ns: "dialog"}),
										  value: PortalBarcodeFormat.aztec
									  },
									  {
										  label: Translate.value("barcode.format.codabar", {ns: "dialog"}),
										  value: PortalBarcodeFormat.codabar
									  },
									  {
										  label: Translate.value("barcode.format.code128", {ns: "dialog"}),
										  value: PortalBarcodeFormat.code128
									  },
									  {
										  label: Translate.value("barcode.format.code39", {ns: "dialog"}),
										  value: PortalBarcodeFormat.code39
									  },
									  {
										  label: Translate.value(
											  "barcode.format.datamatrix", {ns: "dialog"}
										  ),
										  value: PortalBarcodeFormat.datamatrix
									  },
									  {
										  label: Translate.value("barcode.format.ean13", {ns: "dialog"}),
										  value: PortalBarcodeFormat.ean13
									  },
									  {
										  label: Translate.value("barcode.format.ean8", {ns: "dialog"}),
										  value: PortalBarcodeFormat.ean8
									  },
									  {
										  label: Translate.value("barcode.format.itf", {ns: "dialog"}),
										  value: PortalBarcodeFormat.itf
									  },
									  {
										  label: Translate.value("barcode.format.pdf417", {ns: "dialog"}),
										  value: PortalBarcodeFormat.pdf417
									  },
									  {
										  label: Translate.value("barcode.format.upca", {ns: "dialog"}),
										  value: PortalBarcodeFormat.upca
									  }
								  ]}
								  onChange={(e) => this.onChange(BarcodeFields.FORMAT, e.value)}
								  appendTo={document.getElementById("root")}/>
					</div>
				</div>
			</>
		);
	}

	protected renderQrcodeOptions(): ReactNode {
		let parameter: PortalBarcode | undefined = this.state.parameter?.data;

		if (!FunctionHelper.exists(parameter?.add)) {
			return null;
		}

		let addParameter: PortalAddBarcode = parameter!.add as PortalAddBarcode;

		if (addParameter.format !== PortalBarcodeFormat.qrcode) {
			return null;
		}

		return (
			<>
				<div className="p-col-12 p-lg-6 p-grid" hidden={
					!this.state.fields?.contains(BarcodeFields.QRCODE_CORRECTION)
				}>
					<label className="p-col-12 p-sm-5" htmlFor="control-qrcode-correction">
						<Translate {...this.props} data="barcode.create.qrcode.correction.label" namespace="dialog"/>
					</label>
					<div className="p-col-12 p-sm-7 p-grid">
						<Dropdown inputId="control-qrcode-correction"
								  value={FunctionHelper.applyValue(
									  addParameter.qrcode![0]?.errorCorrection, QrBarcode.getErrorCorrectionDefault()
								  )}
								  options={[
									  {
										  label: Translate.value(
											  "barcode.create.qrcode.correction.low", {ns: "dialog"}
										  ),
										  value: QrCodeErrorCorrection.L
									  },
									  {
										  label: Translate.value(
											  "barcode.create.qrcode.correction.medium", {ns: "dialog"}
										  ),
										  value: QrCodeErrorCorrection.M
									  },
									  {
										  label: Translate.value(
											  "barcode.create.qrcode.correction.quartile", {ns: "dialog"}
										  ),
										  value: QrCodeErrorCorrection.Q
									  },
									  {
										  label: Translate.value(
											  "barcode.create.qrcode.correction.high", {ns: "dialog"}
										  ),
										  value: QrCodeErrorCorrection.H
									  }
								  ]}
								  onChange={(e) => this.onChange(BarcodeFields.QRCODE_CORRECTION, e.value)}
								  appendTo={document.getElementById("root")}/>
					</div>
				</div>
			</>
		);
	}

	protected renderAztecOptions(): ReactNode {
		let parameter: PortalBarcode | undefined = this.state.parameter?.data;
		let errors: Map<BarcodeFields, string> = this.state.fieldErrors;

		if (!FunctionHelper.exists(parameter?.add)) {
			return null;
		}

		let addParameter: PortalAddBarcode = parameter!.add as PortalAddBarcode;

		if (addParameter.format !== PortalBarcodeFormat.aztec) {
			return null;
		}

		return (
			<>
				<div className="p-col-12 p-lg-6 p-grid" hidden={
					!this.state.fields?.contains(BarcodeFields.AZTEC_CORRECTION)
				}>
					<label className="p-col-12 p-sm-5" htmlFor="control-aztec-correction">
						<Translate {...this.props} data="barcode.create.aztec.correction" namespace="dialog"/>
					</label>
					<div className="p-col-12 p-sm-7">
						<InputNumber inputId="control-aztec-correction" suffix=" %" showButtons={true} step={1}
									 className={errors.has(BarcodeFields.AZTEC_CORRECTION) ? "p-invalid" : ""}
									 tooltip={errors.has(BarcodeFields.AZTEC_CORRECTION) ? Translate.value(
										 errors.get(BarcodeFields.AZTEC_CORRECTION)!, {ns: "message"}
									 ) : ""}
									 value={FunctionHelper.applyValue(
										 addParameter.aztec![0].errorCorrection,
										 AztecBarcode.getErrorCorrectionDefault()
									 )}
									 min={AztecBarcode.getErrorCorrectionMin()} useGrouping={false}
									 max={AztecBarcode.getErrorCorrectionMax()}
									 onChange={(e) => this.onChange(
										 BarcodeFields.AZTEC_CORRECTION, e.value
									 )}/>
					</div>
				</div>
				<div className="p-col-12 p-lg-6 p-grid" hidden={
					!this.state.fields?.contains(BarcodeFields.AZTEC_LAYER)
				}>
					<label className="p-col-12 p-sm-5" htmlFor="control-aztec-layer">
						<Translate {...this.props} data="barcode.create.aztec.layer" namespace="dialog"/>
					</label>
					<div className="p-col-12 p-sm-7">
						<InputNumber inputId="control-aztec-layer" step={1} showButtons={true} useGrouping={false}
									 className={errors.has(BarcodeFields.AZTEC_LAYER) ? "p-invalid" : ""}
									 tooltip={errors.has(BarcodeFields.AZTEC_LAYER) ? Translate.value(
										 errors.get(BarcodeFields.AZTEC_LAYER)!, {ns: "message"}
									 ) : ""}
									 value={FunctionHelper.applyValue(
										 addParameter.aztec![0].layers, AztecBarcode.getLayersDefault()
									 )}
									 min={AztecBarcode.getLayersMin()} max={AztecBarcode.getLayersMax()}
									 onChange={(e) => this.onChange(
										 BarcodeFields.AZTEC_LAYER, e.value
									 )}/>
					</div>
				</div>
			</>
		);
	}

	protected renderDatamatrixOptions(): ReactNode {
		let parameter: PortalBarcode | undefined = this.state.parameter?.data;
		let errors: Map<BarcodeFields, string> = this.state.fieldErrors;

		if (!FunctionHelper.exists(parameter?.add)) {
			return null;
		}

		let addParameter: PortalAddBarcode = parameter!.add as PortalAddBarcode;

		if (addParameter.format !== PortalBarcodeFormat.datamatrix) {
			return null;
		}

		return (
			<>
				<div className="p-col-12 p-lg-6 p-grid" hidden={
					!this.state.fields?.contains(BarcodeFields.DATAMATRIX_CORRECTION)
				}>
					<label className="p-col-12 p-sm-5" htmlFor="control-datamatrix-correction">
						<Translate {...this.props} data="barcode.create.datamatrix.correction" namespace="dialog"/>
					</label>
					<div className="p-col-12 p-sm-7">
						<InputNumber inputId="control-datamatrix-correction" showButtons={true} step={1}
									 className={errors.has(BarcodeFields.DATAMATRIX_CORRECTION) ? "p-invalid" : ""}
									 tooltip={errors.has(BarcodeFields.DATAMATRIX_CORRECTION) ? Translate.value(
										 errors.get(BarcodeFields.DATAMATRIX_CORRECTION)!, {ns: "message"}
									 ) : ""}
									 value={FunctionHelper.applyValue(
										 addParameter.datamatrix![0].errorCorrection,
										 DataMatrixBarcode.getErrorCorrectionDefault()
									 )}
									 min={DataMatrixBarcode.getErrorCorrectionMin()} useGrouping={false}
									 max={DataMatrixBarcode.getErrorCorrectionMax()}
									 onChange={(e) => this.onChange(
										 BarcodeFields.DATAMATRIX_CORRECTION, e.value
									 )}/>
					</div>
				</div>
				<div className="p-col-12 p-lg-6 p-grid" hidden={
					!this.state.fields?.contains(BarcodeFields.DATAMATRIX_SHAPE)
				}>
					<label className="p-col-12 p-sm-5" htmlFor="control-datamatrix-shape">
						<Translate {...this.props} data="barcode.create.datamatrix.shape.label" namespace="dialog"/>
					</label>
					<div className="p-col-12 p-sm-7 p-grid">
						<Dropdown inputId="control-datamatrix-shape"
								  value={FunctionHelper.applyValue(
									  addParameter.datamatrix![0].shape, DataMatrixBarcode.getShapeDefault()
								  )}
								  options={[
									  {
										  label: Translate.value(
											  "barcode.create.datamatrix.shape.auto", {ns: "dialog"}
										  ),
										  value: DataMatrixShape.Default
									  },
									  {
										  label: Translate.value(
											  "barcode.create.datamatrix.shape.rect", {ns: "dialog"}
										  ),
										  value: DataMatrixShape.Rectangle
									  },
									  {
										  label: Translate.value(
											  "barcode.create.datamatrix.shape.square", {ns: "dialog"}
										  ),
										  value: DataMatrixShape.Square
									  }
								  ]}
								  onChange={(e) => this.onChange(
									  BarcodeFields.DATAMATRIX_SHAPE, e.value
								  )}
								  appendTo={document.getElementById("root")}/>
					</div>
				</div>
			</>
		);
	}

	protected renderPdf417Options(): ReactNode {
		let parameter: PortalBarcode | undefined = this.state.parameter?.data;
		let errors: Map<BarcodeFields, string> = this.state.fieldErrors;

		if (!FunctionHelper.exists(parameter?.add)) {
			return null;
		}

		let addParameter: PortalAddBarcode = parameter!.add as PortalAddBarcode;

		if (addParameter.format !== PortalBarcodeFormat.pdf417) {
			return null;
		}

		return (
			<>
				<div className="p-col-12 p-lg-6 p-grid" hidden={
					!this.state.fields?.contains(BarcodeFields.PDF417_CORRECTION)
				}>
					<label className="p-col-12 p-sm-5" htmlFor="control-pdf417-correction">
						<Translate {...this.props} data="barcode.create.pdf417.correction" namespace="dialog"/>
					</label>
					<div className="p-col-12 p-sm-7">
						<InputNumber inputId="control-pdf417-correction" showButtons={true} step={1} useGrouping={false}
									 className={errors.has(BarcodeFields.PDF417_CORRECTION) ? "p-invalid" : ""}
									 tooltip={errors.has(BarcodeFields.PDF417_CORRECTION) ? Translate.value(
										 errors.get(BarcodeFields.PDF417_CORRECTION)!, {ns: "message"}
									 ) : ""}
									 value={FunctionHelper.applyValue(
										 addParameter.pdf417![0].errorCorrection,
										 Pdf417Barcode.getErrorCorrectionDefault()
									 )}
									 min={Pdf417Barcode.getErrorCorrectionMin()}
									 max={Pdf417Barcode.getErrorCorrectionMax()}
									 onChange={(e) => this.onChange(
										 BarcodeFields.PDF417_CORRECTION, e.value
									 )}/>
					</div>
				</div>
				<div className="p-col-12 p-lg-6 p-grid" hidden={
					!this.state.fields?.contains(BarcodeFields.PDF417_COMPACTION)
				}>
					<label className="p-col-12 p-sm-5" htmlFor="control-pdf417-compaction">
						<Translate {...this.props} data="barcode.create.pdf417.compaction.label" namespace="dialog"/>
					</label>
					<div className="p-col-12 p-sm-7 p-grid">
						<Dropdown inputId="control-pdf417-compaction"
								  value={
									  addParameter.pdf417![0].compact ?
										  addParameter.pdf417![0].compactionMode : COMPACTION_MODE_NONE
								  }
								  options={[
									  {
										  label: Translate.value(
											  "barcode.create.pdf417.compaction.none", {ns: "dialog"}
										  ),
										  value: COMPACTION_MODE_NONE
									  },
									  {
										  label: Translate.value(
											  "barcode.create.pdf417.compaction.auto", {ns: "dialog"}
										  ),
										  value: Pdf417CompactionMode.Auto
									  },
									  {
										  label: Translate.value(
											  "barcode.create.pdf417.compaction.byte", {ns: "dialog"}
										  ),
										  value: Pdf417CompactionMode.Byte
									  },
									  {
										  label: Translate.value(
											  "barcode.create.pdf417.compaction.numeric", {ns: "dialog"}
										  ),
										  value: Pdf417CompactionMode.Numeric
									  },
									  {
										  label: Translate.value(
											  "barcode.create.pdf417.compaction.text", {ns: "dialog"}
										  ),
										  value: Pdf417CompactionMode.Text
									  }
								  ]}
								  onChange={(e) => this.onChange(
									  BarcodeFields.PDF417_COMPACTION, e.value
								  )}
								  appendTo={document.getElementById("root")}/>
					</div>
				</div>
				<div className="p-col-12 p-lg-6 p-grid" hidden={
					!this.state.fields?.contains(BarcodeFields.PDF417_DIMENSIONS)
				}>
					<label className="p-col-12 p-sm-5" htmlFor="control-pdf417-dimensions">
						<Translate {...this.props} data="barcode.create.pdf417.dimensions.label" namespace="dialog"/>
					</label>
					<div className="p-col-12 p-sm-7 switch-container">
						<InputSwitch inputId="control-pdf417-dimensions"
									 checked={FunctionHelper.applyValue(
										 (addParameter.pdf417![0] as PortalPdf417Barcode).dimensions,
										 PortalPdf417Barcode.getDimensionsDefault()
									 )}
									 onChange={(e) => this.onChange(
										 BarcodeFields.PDF417_DIMENSIONS, e.value
									 )}/>
					</div>
				</div>
				<div className="p-col-12 p-lg-6 p-grid" hidden={
					!(addParameter.pdf417![0] as PortalPdf417Barcode).dimensions ||
					!this.state.fields?.contains(BarcodeFields.PDF417_COL_MIN)
				}>
					<label className="p-col-12 p-sm-5" htmlFor="control-pdf417-col-min">
						<Translate {...this.props} data="barcode.create.pdf417.dimensions.col.min" namespace="dialog"/>
					</label>
					<div className="p-col-12 p-sm-7">
						<InputNumber inputId="control-pdf417-col-min" showButtons={true} step={1} useGrouping={false}
									 className={errors.has(BarcodeFields.PDF417_COL_MIN) ? "p-invalid" : ""}
									 tooltip={errors.has(BarcodeFields.PDF417_COL_MIN) ? Translate.value(
										 errors.get(BarcodeFields.PDF417_COL_MIN)!, {ns: "message"}
									 ) : ""}
									 value={FunctionHelper.applyValue(
										 addParameter.pdf417![0].dataCodewordsMin,
										 PortalPdf417Barcode.getDataCodewordsMinDefault()
									 )}
									 min={PortalPdf417Barcode.getDataCodewordsMinMin()}
									 onChange={(e) => this.onChange(
										 BarcodeFields.PDF417_COL_MIN, e.value
									 )}/>
					</div>
				</div>
				<div className="p-col-12 p-lg-6 p-grid" hidden={
					!(addParameter.pdf417![0] as PortalPdf417Barcode).dimensions ||
					!this.state.fields?.contains(BarcodeFields.PDF417_COL_MAX)
				}>
					<label className="p-col-12 p-sm-5" htmlFor="control-pdf417-col-max">
						<Translate {...this.props} data="barcode.create.pdf417.dimensions.col.max" namespace="dialog"/>
					</label>
					<div className="p-col-12 p-sm-7">
						<InputNumber inputId="control-pdf417-col-max" showButtons={true} step={1} useGrouping={false}
									 className={errors.has(BarcodeFields.PDF417_COL_MAX) ? "p-invalid" : ""}
									 tooltip={errors.has(BarcodeFields.PDF417_COL_MAX) ? Translate.value(
										 errors.get(BarcodeFields.PDF417_COL_MAX)!, {ns: "message"}
									 ) : ""}
									 value={FunctionHelper.applyValue(
										 addParameter.pdf417![0].dataCodewordsMax,
										 PortalPdf417Barcode.getDataCodewordsMaxDefault()
									 )}
									 min={PortalPdf417Barcode.getDataCodewordsMaxMin()}
									 onChange={(e) => this.onChange(
										 BarcodeFields.PDF417_COL_MAX, e.value
									 )}/>
					</div>
				</div>
				<div className="p-col-12 p-lg-6 p-grid" hidden={
					!(addParameter.pdf417![0] as PortalPdf417Barcode).dimensions ||
					!this.state.fields?.contains(BarcodeFields.PDF417_ROW_MIN)
				}>
					<label className="p-col-12 p-sm-5" htmlFor="control-pdf417-row-min">
						<Translate {...this.props} data="barcode.create.pdf417.dimensions.row.min" namespace="dialog"/>
					</label>
					<div className="p-col-12 p-sm-7">
						<InputNumber inputId="control-pdf417-row-min" showButtons={true} step={1} useGrouping={false}
									 className={errors.has(BarcodeFields.PDF417_ROW_MIN) ? "p-invalid" : ""}
									 tooltip={errors.has(BarcodeFields.PDF417_ROW_MIN) ? Translate.value(
										 errors.get(BarcodeFields.PDF417_ROW_MIN)!, {ns: "message"}
									 ) : ""}
									 value={FunctionHelper.applyValue(
										 addParameter.pdf417![0].symbolsPerCodewordMin,
										 PortalPdf417Barcode.getSymbolsPerCodewordMinDefault()
									 )}
									 min={PortalPdf417Barcode.getSymbolsPerCodewordMinMin()}
									 onChange={(e) => this.onChange(
										 BarcodeFields.PDF417_ROW_MIN, e.value
									 )}/>
					</div>
				</div>
				<div className="p-col-12 p-lg-6 p-grid" hidden={
					!(addParameter.pdf417![0] as PortalPdf417Barcode).dimensions ||
					!this.state.fields?.contains(BarcodeFields.PDF417_ROW_MAX)
				}>
					<label className="p-col-12 p-sm-5" htmlFor="control-pdf417-row-max">
						<Translate {...this.props} data="barcode.create.pdf417.dimensions.row.max" namespace="dialog"/>
					</label>
					<div className="p-col-12 p-sm-7">
						<InputNumber inputId="control-pdf417-row-max" showButtons={true} step={1} useGrouping={false}
									 className={errors.has(BarcodeFields.PDF417_ROW_MAX) ? "p-invalid" : ""}
									 tooltip={errors.has(BarcodeFields.PDF417_ROW_MAX) ? Translate.value(
										 errors.get(BarcodeFields.PDF417_ROW_MAX)!, {ns: "message"}
									 ) : ""}
									 value={FunctionHelper.applyValue(
										 addParameter.pdf417![0].symbolsPerCodewordMax,
										 PortalPdf417Barcode.getSymbolsPerCodewordMaxDefault()
									 )}
									 min={PortalPdf417Barcode.getSymbolsPerCodewordMaxMin()}
									 onChange={(e) => this.onChange(
										 BarcodeFields.PDF417_ROW_MAX, e.value
									 )}/>
					</div>
				</div>
				<div className="p-col-12 p-lg-6 p-grid" hidden={
					!(addParameter.pdf417![0] as PortalPdf417Barcode).dimensions
				}>
					<label className="p-col-12 p-sm-5"/>
					<div className="p-col-12 p-sm-7">
						<img src={pdf417Example}
							 alt={Translate.value(
								 "barcode.create.pdf417.dimensions.example", {ns: "dialog"}
							 )}/>
					</div>
				</div>
				<div className="p-col-12 p-lg-6 p-grid" hidden={
					!(addParameter.pdf417![0] as PortalPdf417Barcode).dimensions
				}/>
			</>
		);
	}

	protected renderSwissQrCodeOptions(): ReactNode {
		let parameter: PortalBarcode | undefined = this.state.parameter?.data;
		let errors: Map<BarcodeFields, string> = this.state.fieldErrors;

		if (!FunctionHelper.exists(parameter?.add)) {
			return null;
		}

		let addParameter: PortalAddBarcode = parameter!.add as PortalAddBarcode;

		if (addParameter.format !== PortalBarcodeFormat.swissqrcode) {
			return null;
		}

		return (
			<>
				<div className="p-col-12 p-lg-6 p-grid" hidden={
					!this.state.fields?.contains(BarcodeFields.SWISSQRCODE_DPI)
				}>
					<label className="p-col-12 p-sm-5" htmlFor="control-swissqrcode-dpi">
						<Translate {...this.props} data="barcode.create.swissqrcode.dpi" namespace="dialog"/>
					</label>
					<div className="p-col-12 p-sm-7">
						<InputNumber inputId="control-swissqrcode-dpi" min={1} max={9600} step={1} showButtons={true}
									 useGrouping={false}
									 className={errors.has(BarcodeFields.SWISSQRCODE_DPI) ? "p-invalid" : ""}
									 tooltip={errors.has(BarcodeFields.SWISSQRCODE_DPI) ? Translate.value(
										 errors.get(BarcodeFields.SWISSQRCODE_DPI)!, {ns: "message"}
									 ) : ""}
									 value={FunctionHelper.applyValue(
										 addParameter.qrswiss![0]?.dpi, QrSwissPaymentBarcode.getDpiDefault()
									 )} suffix={" " + ImageUnit.DPI}
									 onChange={(e) => this.onChange(
										 BarcodeFields.SWISSQRCODE_DPI, e.value
									 )}/>
					</div>
				</div>
				<div className="p-col-12 p-lg-6 p-grid" hidden={
					!this.state.fields?.contains(BarcodeFields.SWISSQRCODE_LANGUAGE)
				}>
					<label className="p-col-12 p-sm-5" htmlFor="control-swissqrcode-language">
						<Translate {...this.props} data="barcode.create.swissqrcode.language.label" namespace="dialog"/>
					</label>
					<div className="p-col-12 p-sm-7">
						<Dropdown inputId="control-swissqrcode-language"
								  value={FunctionHelper.applyValue(
									  addParameter.qrswiss![0]?.language, QrSwissPaymentBarcode.getLanguageDefault()
								  )}
								  onChange={(e) => this.onChange(
									  BarcodeFields.SWISSQRCODE_LANGUAGE, e.value
								  )}
								  appendTo={document.getElementById("root")}
								  options={[
									  {
										  label: Translate.value(
											  "barcode.create.swissqrcode.language.german", {ns: "dialog"}
										  ),
										  value: QrSwissPaymentLanguage.De
									  },
									  {
										  label: Translate.value(
											  "barcode.create.swissqrcode.language.english", {ns: "dialog"}
										  ),
										  value: QrSwissPaymentLanguage.En
									  },
									  {
										  label: Translate.value(
											  "barcode.create.swissqrcode.language.french", {ns: "dialog"}
										  ),
										  value: QrSwissPaymentLanguage.Fr
									  },
									  {
										  label: Translate.value(
											  "barcode.create.swissqrcode.language.italian", {ns: "dialog"}
										  ),
										  value: QrSwissPaymentLanguage.It
									  }
								  ]}/>
					</div>
				</div>
			</>
		);
	}

	protected renderGeneralOptions(): ReactNode {
		let parameter: PortalBarcode | undefined = this.state.parameter?.data;
		let errors: Map<BarcodeFields, string> = this.state.fieldErrors;

		if (!FunctionHelper.exists(parameter?.add)) {
			return null;
		}

		let addParameter: PortalAddBarcode = parameter!.add as PortalAddBarcode;

		if (addParameter.format === PortalBarcodeFormat.swissqrcode) {
			return null;
		}

		let width: number = addParameter.getFormatWidth();
		let height: number = addParameter.getFormatHeight();
		let margin: number = addParameter.getFormatMargin();
		let marginMin: number = addParameter.getFormatMarginMin();
		let rotation: number = addParameter.getFormatRotation();

		return (
			<>
				<div className="p-col-12 p-lg-6 p-grid" hidden={
					!this.state.fields?.contains(BarcodeFields.WIDTH)
				}>
					<label className="p-col-12 p-sm-5" htmlFor="control-width">
						<Translate {...this.props} data="barcode.create.width" namespace="dialog"/>
					</label>
					<div className="p-col-12 p-sm-7">
						<InputNumber inputId="control-width" step={1} maxFractionDigits={2} showButtons={true} min={0}
									 className={errors.has(BarcodeFields.WIDTH) ? "p-invalid" : ""} useGrouping={false}
									 tooltip={errors.has(BarcodeFields.WIDTH) ? Translate.value(
										 errors.get(BarcodeFields.WIDTH)!, {ns: "message"}
									 ) : ""}
									 value={UnitHelper.unitToUnit(
										 width, LengthUnit.MILLIMETER, this.state.unit, this.props.portalResolution
									 )}
									 minFractionDigits={2} suffix={" " + this.state.unit}
									 onChange={(e) => this.onChange(
										 BarcodeFields.WIDTH, e.value
									 )}/>
					</div>
				</div>
				<div className="p-col-12 p-lg-6 p-grid" hidden={
					!this.state.fields?.contains(BarcodeFields.HEIGHT)
				}>
					<label className="p-col-12 p-sm-5" htmlFor="control-height">
						<Translate {...this.props} data="barcode.create.height" namespace="dialog"/>
					</label>
					<div className="p-col-12 p-sm-7">
						<InputNumber inputId="control-height" maxFractionDigits={2} showButtons={true} step={1}
									 className={errors.has(BarcodeFields.HEIGHT) ? "p-invalid" : ""} useGrouping={false}
									 tooltip={errors.has(BarcodeFields.HEIGHT) ? Translate.value(
										 errors.get(BarcodeFields.HEIGHT)!, {ns: "message"}
									 ) : ""}
									 value={UnitHelper.unitToUnit(
										 height, LengthUnit.MILLIMETER, this.state.unit, this.props.portalResolution
									 )}
									 minFractionDigits={2} suffix={" " + this.state.unit} min={0}
									 onChange={(e) => this.onChange(
										 BarcodeFields.HEIGHT, e.value
									 )}/>
					</div>
				</div>
				<div className="p-col-12 p-lg-6 p-grid" hidden={
					!this.state.fields?.contains(BarcodeFields.MARGIN)
				}>
					<label className="p-col-12 p-sm-5" htmlFor="control-margin">
						<Translate {...this.props} data="barcode.create.margin" namespace="dialog"/>
					</label>
					<div className="p-col-12 p-sm-7">
						<InputNumber inputId="control-margin" step={1} maxFractionDigits={2} showButtons={true}
									 className={errors.has(BarcodeFields.MARGIN) ? "p-invalid" : ""} useGrouping={false}
									 tooltip={errors.has(BarcodeFields.MARGIN) ? Translate.value(
										 errors.get(BarcodeFields.MARGIN)!, {ns: "message"}
									 ) : ""}
									 value={UnitHelper.unitToUnit(
										 margin, LengthUnit.MILLIMETER, this.state.unit, this.props.portalResolution
									 )}
									 min={marginMin} minFractionDigits={2} suffix={" " + this.state.unit}
									 onChange={(e) => this.onChange(
										 BarcodeFields.MARGIN, e.value
									 )}/>
					</div>
				</div>
				<Helper {...this.props}>
					<Translate {...this.props} data={"dialog.barcode.margin"} namespace={"help"} markdown={true}/>
				</Helper>
				<div className="p-col-12 p-lg-6 p-grid" hidden={
					!this.state.fields?.contains(BarcodeFields.ROTATION)
				}>
					<label className="p-col-12 p-sm-5" htmlFor="control-rotation">
						<Translate {...this.props} data="barcode.create.rotation" namespace="dialog"/>
					</label>
					<div className="p-col-12 p-sm-7 p-grid">
						<Dropdown inputId="control-rotation" value={rotation}
								  options={[
									  {label: "0 °", value: 0},
									  {label: "90 °", value: 90},
									  {label: "180 °", value: 180},
									  {label: "270 °", value: 270}
								  ]}
								  onChange={(e) => this.onChange(BarcodeFields.ROTATION, e.value)}
								  appendTo={document.getElementById("root")}/>
					</div>
				</div>
			</>
		);
	}

	protected renderPreview(): ReactNode {
		let parameter: PortalBarcode | undefined = this.state.parameter?.data;

		if (!FunctionHelper.exists(parameter?.add)) {
			return null;
		}

		let addParameter: PortalAddBarcode = parameter!.add as PortalAddBarcode;

		let imageSource: string | undefined;
		if (addParameter.format === PortalBarcodeFormat.swissqrcode) {
			if (this.previewImages.get(addParameter.qrswiss![0]?.format!)?.has(addParameter.qrswiss![0]?.separator!)) {
				imageSource = this.previewImages.get(addParameter.qrswiss![0]?.format!)?.get(
					addParameter.qrswiss![0]?.separator!
				);
			} else {
				imageSource = this.previewImages.get(addParameter.qrswiss![0]?.format!)?.get(
					QrSwissPaymentSeparator.None
				);
			}
		}

		return (
			<>
				<div className="p-col-12 p-xl-4 p-lg-hidden p-grid divider-left"
					 style={{opacity: this.state.showPreview ? 1 : 0}}>
					<fieldset className="p-col-12 p-grid" hidden={!this.state.fields?.contains(BarcodeFields.PREVIEW)}>
						<div className="barcode-preview p-col-12">
							<canvas id="barcode-preview" ref={(ref) => {
								if (!FunctionHelper.exists(ref)) {
									return;
								}

								this.barcodePreview = ref!
								this.buildPreview(addParameter!);
							}} style={{
								display: FunctionHelper.applyValue(
									addParameter?.format, PortalAddBarcode.getFormatDefault()
								) !== PortalBarcodeFormat.swissqrcode ? "block" : "none"
							}}/>
							<img src={imageSource}
								 alt={Translate.value("barcode.create.swissqrcode.example", {ns: "dialog"})}
								 style={{
									 display: addParameter.format === PortalBarcodeFormat.swissqrcode ? "block" : "none"
								 }}/>
						</div>
					</fieldset>
				</div>
			</>
		);
	}

	protected async onChange(field: BarcodeFields, value: any): Promise<void> {
		let parameter: PortalBarcode = this.state.parameter!.data;
		let addParameter: PortalAddBarcode = parameter.add as PortalAddBarcode;
		let errors: Map<BarcodeFields, string> = this.state.fieldErrors;
		let hasError: boolean = false;

		switch (field) {
			case BarcodeFields.FORMAT:
				addParameter.format = value;
				await this.onChange(BarcodeFields.CONTENT, addParameter.getFormatContent());
				break;
			case BarcodeFields.CONTENT:
				if (!FunctionHelper.exists(value) || FunctionHelper.isEmpty(value)) {
					errors.set(field, "errors.fields.set");
					hasError = true;
				}

				switch (addParameter.format) {
					case PortalBarcodeFormat.aztec:
						addParameter.aztec![0].value = value;
						break;
					case PortalBarcodeFormat.codabar:
						if (!BarcodeHelper.checkCodabarBoundary(value)) {
							errors.set(field, "errors.barcode.codabar_boundaries");
							hasError = true;
						} else if (!(await BarcodeHelper.isCodabar(value))) {
							errors.set(field, "errors.barcode.codabar");
							hasError = true;
						}

						addParameter.codabar![0].value = value;
						break;
					case PortalBarcodeFormat.code39:
						if (!(await BarcodeHelper.isCode39(value))) {
							errors.set(field, "errors.barcode.code39");
							hasError = true;
						}

						addParameter.code39![0].value = value;
						break;
					case PortalBarcodeFormat.code128:
						addParameter.code128![0].value = value;
						break;
					case PortalBarcodeFormat.datamatrix:
						addParameter.datamatrix![0].value = value;
						break;
					case PortalBarcodeFormat.ean8:
						if (!(await BarcodeHelper.isEan8(value))) {
							errors.set(field, "errors.barcode.ean8");
							hasError = true;
						}

						addParameter.ean8![0].value = value;
						break;
					case PortalBarcodeFormat.ean13:
						if (!(await BarcodeHelper.isEan13(value))) {
							errors.set(field, "errors.barcode.ean13");
							hasError = true;
						}

						addParameter.ean13![0].value = value;
						break;
					case PortalBarcodeFormat.itf:
						if (!(await BarcodeHelper.isItf(value))) {
							errors.set(field, "errors.barcode.itf");
							hasError = true;
						}

						addParameter.itf![0].value = value;
						break;
					case PortalBarcodeFormat.pdf417:
						addParameter.pdf417![0].value = value;
						break;
					case PortalBarcodeFormat.qrcode:
						addParameter.qrcode![0].value = value;
						break;
					case PortalBarcodeFormat.upca:
						if (!(await BarcodeHelper.isUpca(value))) {
							errors.set(field, "errors.barcode.upca");
							hasError = true;
						}

						addParameter.upca![0].value = value;
						break;
					case PortalBarcodeFormat.swissqrcode:
						addParameter.qrswiss![0].content!.value = value;
						break;
				}

				if (!hasError && errors.has(field)) {
					errors.delete(field);
				}
				break;
			case BarcodeFields.WIDTH:
				if (!FunctionHelper.exists(value) || FunctionHelper.isEmpty(value)) {
					value = Rectangle.getWidthDefault();
				}

				switch (addParameter.format) {
					case PortalBarcodeFormat.aztec:
						addParameter.aztec![0].position!.width = UnitHelper.unitToUnit(
							value, this.state.unit, LengthUnit.MILLIMETER, this.props.portalResolution
						);
						break;
					case PortalBarcodeFormat.codabar:
						addParameter.codabar![0].position!.width = UnitHelper.unitToUnit(
							value, this.state.unit, LengthUnit.MILLIMETER, this.props.portalResolution
						);
						break;
					case PortalBarcodeFormat.code39:
						addParameter.code39![0].position!.width = UnitHelper.unitToUnit(
							value, this.state.unit, LengthUnit.MILLIMETER, this.props.portalResolution
						);
						break;
					case PortalBarcodeFormat.code128:
						addParameter.code128![0].position!.width = UnitHelper.unitToUnit(
							value, this.state.unit, LengthUnit.MILLIMETER, this.props.portalResolution
						);
						break;
					case PortalBarcodeFormat.datamatrix:
						addParameter.datamatrix![0].position!.width = UnitHelper.unitToUnit(
							value, this.state.unit, LengthUnit.MILLIMETER, this.props.portalResolution
						);
						break;
					case PortalBarcodeFormat.ean8:
						addParameter.ean8![0].position!.width = UnitHelper.unitToUnit(
							value, this.state.unit, LengthUnit.MILLIMETER, this.props.portalResolution
						);
						break;
					case PortalBarcodeFormat.ean13:
						addParameter.ean13![0].position!.width = UnitHelper.unitToUnit(
							value, this.state.unit, LengthUnit.MILLIMETER, this.props.portalResolution
						);
						break;
					case PortalBarcodeFormat.itf:
						addParameter.itf![0].position!.width = UnitHelper.unitToUnit(
							value, this.state.unit, LengthUnit.MILLIMETER, this.props.portalResolution
						);
						break;
					case PortalBarcodeFormat.pdf417:
						addParameter.pdf417![0].position!.width = UnitHelper.unitToUnit(
							value, this.state.unit, LengthUnit.MILLIMETER, this.props.portalResolution
						);
						break;
					case PortalBarcodeFormat.qrcode:
						addParameter.qrcode![0].position!.width = UnitHelper.unitToUnit(
							value, this.state.unit, LengthUnit.MILLIMETER, this.props.portalResolution
						);
						break;
					case PortalBarcodeFormat.upca:
						addParameter.upca![0].position!.width = UnitHelper.unitToUnit(
							value, this.state.unit, LengthUnit.MILLIMETER, this.props.portalResolution
						);
						break;
					case PortalBarcodeFormat.swissqrcode:
						addParameter.qrswiss![0].position!.width = UnitHelper.unitToUnit(
							value, this.state.unit, LengthUnit.MILLIMETER, this.props.portalResolution
						);
						break;
				}
				break;
			case BarcodeFields.HEIGHT:
				if (!FunctionHelper.exists(value) || FunctionHelper.isEmpty(value)) {
					value = Rectangle.getHeightDefault();
				}

				switch (addParameter.format) {
					case PortalBarcodeFormat.aztec:
						addParameter.aztec![0].position!.height = UnitHelper.unitToUnit(
							value, this.state.unit, LengthUnit.MILLIMETER, this.props.portalResolution
						);
						break;
					case PortalBarcodeFormat.codabar:
						addParameter.codabar![0].position!.height = UnitHelper.unitToUnit(
							value, this.state.unit, LengthUnit.MILLIMETER, this.props.portalResolution
						);
						break;
					case PortalBarcodeFormat.code39:
						addParameter.code39![0].position!.height = UnitHelper.unitToUnit(
							value, this.state.unit, LengthUnit.MILLIMETER, this.props.portalResolution
						);
						break;
					case PortalBarcodeFormat.code128:
						addParameter.code128![0].position!.height = UnitHelper.unitToUnit(
							value, this.state.unit, LengthUnit.MILLIMETER, this.props.portalResolution
						);
						break;
					case PortalBarcodeFormat.datamatrix:
						addParameter.datamatrix![0].position!.height = UnitHelper.unitToUnit(
							value, this.state.unit, LengthUnit.MILLIMETER, this.props.portalResolution
						);
						break;
					case PortalBarcodeFormat.ean8:
						addParameter.ean8![0].position!.height = UnitHelper.unitToUnit(
							value, this.state.unit, LengthUnit.MILLIMETER, this.props.portalResolution
						);
						break;
					case PortalBarcodeFormat.ean13:
						addParameter.ean13![0].position!.height = UnitHelper.unitToUnit(
							value, this.state.unit, LengthUnit.MILLIMETER, this.props.portalResolution
						);
						break;
					case PortalBarcodeFormat.itf:
						addParameter.itf![0].position!.height = UnitHelper.unitToUnit(
							value, this.state.unit, LengthUnit.MILLIMETER, this.props.portalResolution
						);
						break;
					case PortalBarcodeFormat.pdf417:
						addParameter.pdf417![0].position!.height = UnitHelper.unitToUnit(
							value, this.state.unit, LengthUnit.MILLIMETER, this.props.portalResolution
						);
						break;
					case PortalBarcodeFormat.qrcode:
						addParameter.qrcode![0].position!.height = UnitHelper.unitToUnit(
							value, this.state.unit, LengthUnit.MILLIMETER, this.props.portalResolution
						);
						break;
					case PortalBarcodeFormat.upca:
						addParameter.upca![0].position!.height = UnitHelper.unitToUnit(
							value, this.state.unit, LengthUnit.MILLIMETER, this.props.portalResolution
						);
						break;
					case PortalBarcodeFormat.swissqrcode:
						addParameter.qrswiss![0].position!.height = UnitHelper.unitToUnit(
							value, this.state.unit, LengthUnit.MILLIMETER, this.props.portalResolution
						);
						break;
				}
				break;
			case BarcodeFields.MARGIN:
				if (!FunctionHelper.exists(value) || FunctionHelper.isEmpty(value)) {
					value = addParameter.getFormatMarginMin();
				}

				switch (addParameter.format) {
					case PortalBarcodeFormat.aztec:
						addParameter.aztec![0].margin = UnitHelper.unitToUnit(
							value, this.state.unit, LengthUnit.MILLIMETER, this.props.portalResolution
						);
						break;
					case PortalBarcodeFormat.codabar:
						addParameter.codabar![0].margin = UnitHelper.unitToUnit(
							value, this.state.unit, LengthUnit.MILLIMETER, this.props.portalResolution
						);
						break;
					case PortalBarcodeFormat.code39:
						addParameter.code39![0].margin = UnitHelper.unitToUnit(
							value, this.state.unit, LengthUnit.MILLIMETER, this.props.portalResolution
						);
						break;
					case PortalBarcodeFormat.code128:
						addParameter.code128![0].margin = UnitHelper.unitToUnit(
							value, this.state.unit, LengthUnit.MILLIMETER, this.props.portalResolution
						);
						break;
					case PortalBarcodeFormat.datamatrix:
						addParameter.datamatrix![0].margin = UnitHelper.unitToUnit(
							value, this.state.unit, LengthUnit.MILLIMETER, this.props.portalResolution
						);
						break;
					case PortalBarcodeFormat.ean8:
						addParameter.ean8![0].margin = UnitHelper.unitToUnit(
							value, this.state.unit, LengthUnit.MILLIMETER, this.props.portalResolution
						);
						break;
					case PortalBarcodeFormat.ean13:
						addParameter.ean13![0].margin = UnitHelper.unitToUnit(
							value, this.state.unit, LengthUnit.MILLIMETER, this.props.portalResolution
						);
						break;
					case PortalBarcodeFormat.itf:
						addParameter.itf![0].margin = UnitHelper.unitToUnit(
							value, this.state.unit, LengthUnit.MILLIMETER, this.props.portalResolution
						);
						break;
					case PortalBarcodeFormat.pdf417:
						addParameter.pdf417![0].margin = UnitHelper.unitToUnit(
							value, this.state.unit, LengthUnit.MILLIMETER, this.props.portalResolution
						);
						break;
					case PortalBarcodeFormat.qrcode:
						addParameter.qrcode![0].margin = UnitHelper.unitToUnit(
							value, this.state.unit, LengthUnit.MILLIMETER, this.props.portalResolution
						);
						break;
					case PortalBarcodeFormat.upca:
						addParameter.upca![0].margin = UnitHelper.unitToUnit(
							value, this.state.unit, LengthUnit.MILLIMETER, this.props.portalResolution
						);
						break;
				}
				break;
			case BarcodeFields.ROTATION:
				switch (addParameter.format) {
					case PortalBarcodeFormat.aztec:
						addParameter.aztec![0].rotation = value;
						break;
					case PortalBarcodeFormat.codabar:
						addParameter.codabar![0].rotation = value;
						break;
					case PortalBarcodeFormat.code39:
						addParameter.code39![0].rotation = value;
						break;
					case PortalBarcodeFormat.code128:
						addParameter.code128![0].rotation = value;
						break;
					case PortalBarcodeFormat.datamatrix:
						addParameter.datamatrix![0].rotation = value;
						break;
					case PortalBarcodeFormat.ean8:
						addParameter.ean8![0].rotation = value;
						break;
					case PortalBarcodeFormat.ean13:
						addParameter.ean13![0].rotation = value;
						break;
					case PortalBarcodeFormat.itf:
						addParameter.itf![0].rotation = value;
						break;
					case PortalBarcodeFormat.pdf417:
						addParameter.pdf417![0].rotation = value;
						break;
					case PortalBarcodeFormat.qrcode:
						addParameter.qrcode![0].rotation = value;
						break;
					case PortalBarcodeFormat.upca:
						addParameter.upca![0].rotation = value;
						break;
				}
				break;
			case BarcodeFields.QRCODE_CORRECTION:
				addParameter.qrcode![0].errorCorrection = value;
				break;
			case BarcodeFields.AZTEC_CORRECTION:
				if (!FunctionHelper.exists(value) || FunctionHelper.isEmpty(value)) {
					value = AztecBarcode.getErrorCorrectionDefault();
				}

				addParameter.aztec![0].errorCorrection = value;
				break;
			case BarcodeFields.AZTEC_LAYER:
				if (!FunctionHelper.exists(value) || FunctionHelper.isEmpty(value)) {
					value = AztecBarcode.getLayersDefault();
				}

				addParameter.aztec![0].layers = value;
				break;
			case BarcodeFields.DATAMATRIX_CORRECTION:
				if (!FunctionHelper.exists(value) || FunctionHelper.isEmpty(value)) {
					value = DataMatrixBarcode.getErrorCorrectionDefault();
				}

				addParameter.datamatrix![0].errorCorrection = value;
				break;
			case BarcodeFields.DATAMATRIX_SHAPE:
				addParameter.datamatrix![0].shape = value;
				break;
			case BarcodeFields.PDF417_CORRECTION:
				if (!FunctionHelper.exists(value) || FunctionHelper.isEmpty(value)) {
					value = Pdf417Barcode.getErrorCorrectionDefault();
				}

				addParameter.pdf417![0].errorCorrection = value;
				break;
			case BarcodeFields.PDF417_COMPACTION:
				if (value === COMPACTION_MODE_NONE) {
					addParameter.pdf417![0].compact = false;
					break;
				}

				addParameter.pdf417![0].compact = true;
				addParameter.pdf417![0].compactionMode = value;
				break;
			case BarcodeFields.PDF417_DIMENSIONS:
				(addParameter.pdf417![0] as PortalPdf417Barcode).dimensions = value;
				break;
			case BarcodeFields.PDF417_COL_MIN:
				addParameter.pdf417![0].dataCodewordsMin = value;
				break;
			case BarcodeFields.PDF417_COL_MAX:
				addParameter.pdf417![0].dataCodewordsMax = value;
				break;
			case BarcodeFields.PDF417_ROW_MIN:
				addParameter.pdf417![0].symbolsPerCodewordMin = value;
				break;
			case BarcodeFields.PDF417_ROW_MAX:
				addParameter.pdf417![0].symbolsPerCodewordMax = value;
				break;
			case BarcodeFields.SWISSQRCODE_DPI:
				if (!FunctionHelper.exists(value) || FunctionHelper.isEmpty(value)) {
					value = QrSwissPaymentBarcode.getDpiDefault();
				}

				addParameter.qrswiss![0].dpi = value;
				break;
			case BarcodeFields.SWISSQRCODE_LANGUAGE:
				addParameter.qrswiss![0].language = value;
				break;
			case BarcodeFields.SWISSQRCODE_CONTENT_FORMAT:
				let content: string = FunctionHelper.applyValue(
					addParameter.qrswiss![0].content!.value, ""
				);

				let currentFormat: QrSwissPaymentContentFormat = addParameter.qrswiss![0].content!.format!;
				if (currentFormat !== value) {
					content = SwissQrCodeForm.fromSwissQrCode(content, currentFormat).toSwissQrCode(value);
				}

				addParameter.qrswiss![0].content!.format = value;
				addParameter.qrswiss![0].content!.value = content;
				break;
			case BarcodeFields.SWISSQRCODE_SEPARATOR:
				addParameter.qrswiss![0].separator = value;
				break;
			case BarcodeFields.SWISSQRCODE_FORMAT:
				addParameter.qrswiss![0].format = value;
				break;
			case BarcodeFields.FILENAME:
				if (!FunctionHelper.exists(value) || FunctionHelper.isEmpty(value)) {
					errors.set(field, "errors.fields.set");
				} else if (!FileHelper.isFilename(value)) {
					errors.set(field, "errors.fields.filename");
				} else if (errors.has(field)) {
					errors.delete(field);
				}

				addParameter.fileName = value;
				break;
		}

		this.setState({
			parameter: this.state.parameter
		});
	}

	/**
	 * Render the dialog footer
	 */
	protected renderFooter(): ReactNode {
		return (
			<div className="p-grid">
				<div className="p-col-12 p-xl-8 p-grid divider-right-hidden">
					<fieldset className="p-col-12 p-grid">
						<div className="p-col-12 p-grid">
							<div className="p-col-12 p-grid">
								<Button label={Translate.value("buttons.reset")} icon={"icon icon-rotate-270 small"}
										disabled={this.state.submitted} className="reset-button"
										onClick={() => this.resetParameter()}/>
								<Button label={Translate.value("buttons.submit")} disabled={!this.isValid()}
										icon={"icon" + (this.state.submitted ? " icon-spinner spin" : " icon-check")}
										className="primary-button" onClick={() => this.submit()}/>
								{this.state.submitted ?
									<Button label={Translate.value("buttons.close")} icon="icon icon-close"
											onClick={() => this.hide()} className="dialog-button"/> :
									<Button label={Translate.value("buttons.cancel")} icon="icon icon-close"
											onClick={() => this.hide()} className="dialog-button"/>
								}
							</div>
						</div>
					</fieldset>
				</div>
				<div className="p-col-12 p-xl-4 p-lg-hidden p-grid divider-left-hidden"></div>
			</div>
		);
	}

	protected isEditPasswordNeeded(portalDocument: PortalDocument): boolean {
		return super.isEditPasswordNeeded(portalDocument) && !FunctionHelper.applyValue(
			portalDocument.metadata?.security?.canModify, Security.getCanModifyDefault()
		);
	}

	protected cleanupOperationData(): PortalBarcode {
		let operationData: PortalBarcode = this.state.parameter!.data.clone();

		switch ((operationData.add as PortalAddBarcode).format) {
			case PortalBarcodeFormat.upca:
				operationData.add!.qrcode = undefined;
				operationData.add!.pdf417 = undefined;
				operationData.add!.itf = undefined;
				operationData.add!.ean13 = undefined;
				operationData.add!.ean8 = undefined;
				operationData.add!.datamatrix = undefined;
				operationData.add!.code128 = undefined;
				operationData.add!.code39 = undefined;
				operationData.add!.codabar = undefined;
				operationData.add!.aztec = undefined;
				operationData.add!.qrswiss = undefined;
				break;
			case PortalBarcodeFormat.qrcode:
				operationData.add!.upca = undefined;
				operationData.add!.pdf417 = undefined;
				operationData.add!.itf = undefined;
				operationData.add!.ean13 = undefined;
				operationData.add!.ean8 = undefined;
				operationData.add!.datamatrix = undefined;
				operationData.add!.code128 = undefined;
				operationData.add!.code39 = undefined;
				operationData.add!.codabar = undefined;
				operationData.add!.aztec = undefined;
				operationData.add!.qrswiss = undefined;
				break;
			case PortalBarcodeFormat.pdf417:
				operationData.add!.upca = undefined;
				operationData.add!.qrcode = undefined;
				operationData.add!.itf = undefined;
				operationData.add!.ean13 = undefined;
				operationData.add!.ean8 = undefined;
				operationData.add!.datamatrix = undefined;
				operationData.add!.code128 = undefined;
				operationData.add!.code39 = undefined;
				operationData.add!.codabar = undefined;
				operationData.add!.aztec = undefined;
				operationData.add!.qrswiss = undefined;
				break;
			case PortalBarcodeFormat.itf:
				operationData.add!.upca = undefined;
				operationData.add!.qrcode = undefined;
				operationData.add!.pdf417 = undefined;
				operationData.add!.ean13 = undefined;
				operationData.add!.ean8 = undefined;
				operationData.add!.datamatrix = undefined;
				operationData.add!.code128 = undefined;
				operationData.add!.code39 = undefined;
				operationData.add!.codabar = undefined;
				operationData.add!.aztec = undefined;
				operationData.add!.qrswiss = undefined;
				break;
			case PortalBarcodeFormat.ean13:
				operationData.add!.upca = undefined;
				operationData.add!.qrcode = undefined;
				operationData.add!.pdf417 = undefined;
				operationData.add!.itf = undefined;
				operationData.add!.ean8 = undefined;
				operationData.add!.datamatrix = undefined;
				operationData.add!.code128 = undefined;
				operationData.add!.code39 = undefined;
				operationData.add!.codabar = undefined;
				operationData.add!.aztec = undefined;
				operationData.add!.qrswiss = undefined;
				break;
			case PortalBarcodeFormat.ean8:
				operationData.add!.upca = undefined;
				operationData.add!.qrcode = undefined;
				operationData.add!.pdf417 = undefined;
				operationData.add!.itf = undefined;
				operationData.add!.ean13 = undefined;
				operationData.add!.datamatrix = undefined;
				operationData.add!.code128 = undefined;
				operationData.add!.code39 = undefined;
				operationData.add!.codabar = undefined;
				operationData.add!.aztec = undefined;
				operationData.add!.qrswiss = undefined;
				break;
			case PortalBarcodeFormat.datamatrix:
				operationData.add!.upca = undefined;
				operationData.add!.qrcode = undefined;
				operationData.add!.pdf417 = undefined;
				operationData.add!.itf = undefined;
				operationData.add!.ean13 = undefined;
				operationData.add!.ean8 = undefined;
				operationData.add!.code128 = undefined;
				operationData.add!.code39 = undefined;
				operationData.add!.codabar = undefined;
				operationData.add!.aztec = undefined;
				operationData.add!.qrswiss = undefined;
				break;
			case PortalBarcodeFormat.code128:
				operationData.add!.upca = undefined;
				operationData.add!.qrcode = undefined;
				operationData.add!.pdf417 = undefined;
				operationData.add!.itf = undefined;
				operationData.add!.ean13 = undefined;
				operationData.add!.ean8 = undefined;
				operationData.add!.datamatrix = undefined;
				operationData.add!.code39 = undefined;
				operationData.add!.codabar = undefined;
				operationData.add!.aztec = undefined;
				operationData.add!.qrswiss = undefined;
				break;
			case PortalBarcodeFormat.code39:
				operationData.add!.upca = undefined;
				operationData.add!.qrcode = undefined;
				operationData.add!.pdf417 = undefined;
				operationData.add!.itf = undefined;
				operationData.add!.ean13 = undefined;
				operationData.add!.ean8 = undefined;
				operationData.add!.datamatrix = undefined;
				operationData.add!.code128 = undefined;
				operationData.add!.codabar = undefined;
				operationData.add!.aztec = undefined;
				operationData.add!.qrswiss = undefined;
				break;
			case PortalBarcodeFormat.codabar:
				operationData.add!.upca = undefined;
				operationData.add!.qrcode = undefined;
				operationData.add!.pdf417 = undefined;
				operationData.add!.itf = undefined;
				operationData.add!.ean13 = undefined;
				operationData.add!.ean8 = undefined;
				operationData.add!.datamatrix = undefined;
				operationData.add!.code128 = undefined;
				operationData.add!.code39 = undefined;
				operationData.add!.aztec = undefined;
				operationData.add!.qrswiss = undefined;
				break;
			case PortalBarcodeFormat.aztec:
				operationData.add!.upca = undefined;
				operationData.add!.qrcode = undefined;
				operationData.add!.pdf417 = undefined;
				operationData.add!.itf = undefined;
				operationData.add!.ean13 = undefined;
				operationData.add!.ean8 = undefined;
				operationData.add!.datamatrix = undefined;
				operationData.add!.code128 = undefined;
				operationData.add!.code39 = undefined;
				operationData.add!.codabar = undefined;
				operationData.add!.qrswiss = undefined;
				break;
			case PortalBarcodeFormat.swissqrcode:
				operationData.add!.upca = undefined;
				operationData.add!.qrcode = undefined;
				operationData.add!.pdf417 = undefined;
				operationData.add!.itf = undefined;
				operationData.add!.ean13 = undefined;
				operationData.add!.ean8 = undefined;
				operationData.add!.datamatrix = undefined;
				operationData.add!.code128 = undefined;
				operationData.add!.code39 = undefined;
				operationData.add!.codabar = undefined;
				operationData.add!.aztec = undefined;
		}

		return operationData;
	}

	protected async handleKeydown(event: KeyboardEvent): Promise<void> {
		if (!this.mounted || !this.props.visible) {
			return;
		}

		let errors: Map<any, string> = this.state.fieldErrors;

		if (event.key.toLowerCase() === "enter" && !this.state.submitted && errors.size === 0) {
			event.stopImmediatePropagation();
		}
	}

	/**
	 * Handle showing/initializing the dialog
	 */
	protected async onShow(): Promise<void> {
		await super.onShow();

		let parameter: PortalBarcode | undefined = this.state.parameter?.data;

		if (!FunctionHelper.exists(parameter?.add)) {
			return;
		}

		let addParameter: PortalAddBarcode = parameter!.add as PortalAddBarcode;

		if (addParameter.fileName === "") {
			addParameter.fileName = Translate.value("barcode.generate.filename.default", {ns: "dialog"});
		}

		let userSettings: UserSettings = UserSettings.fromJson(this.props.userSettings.get());
		this.setState({
			unit: userSettings.unit,
			parameter: this.state.parameter,
			defaultParameter: this.state.parameter?.clone(),
			previewBuild: false
		});
	};

	protected getDefaultParameter(): Parameter<PortalBarcode> {
		return DialogDefault.getParameter(
			this.getDialogType(), this.props.context.documentManager.getSelection()
		);
	}
}